import {homeActions} from "src/feature/home-test/reducers";

export const GET_FACTS: string = "GET_FACTS";
export const GET_USERS: string = "GET_USERS";
export const VERIFY_USER: string = "VERIFY_USER";
export const SET_USERS: string = "SET_USERS";
export const SET_FACTS: string = homeActions.setFacts.type;
export const SET_TOKEN: string = homeActions.setToken.type;
